const map = {
  currentPage: 'X-Pagination-Current-Page',
  perPage: 'X-Pagination-Per-Page',
  pageCount: 'X-Pagination-Page-Count',
  totalCount: 'X-Pagination-Total-Count'
}

export default (headers) => {
  if (headers) {
    let pager = {
      currentPage: 1,
      perPage: 20,
      pageCount: 0,
      totalCount: 0
    }

    for (let propName in map) {
      let headerName = map[propName].toLowerCase()
      if (Object.hasOwn(headers, headerName)) {
        pager[propName] = +headers[headerName]
      }
    }
    return pager
  } else {
    throw new Error('Got empty headers in pager parser.')
  }
}
